import { render, staticRenderFns } from "./KommunetorgetListPage.vue?vue&type=template&id=38a8aba5&"
import script from "./KommunetorgetListPage.vue?vue&type=script&lang=js&"
export * from "./KommunetorgetListPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\src\\KoRus.Kommunetorget\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('38a8aba5')) {
      api.createRecord('38a8aba5', component.options)
    } else {
      api.reload('38a8aba5', component.options)
    }
    module.hot.accept("./KommunetorgetListPage.vue?vue&type=template&id=38a8aba5&", function () {
      api.rerender('38a8aba5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "Assets/Scripts/components/pages/KommunetorgetListPage.vue"
export default component.exports